module.exports = __webpack_public_path__ + "img/ctrl-st-stub-mid--i.e3edf09c.svg";